import { Disciplines } from "~enums/disciplines.ts";
import type { TableColumnGroupDefinition } from "~types/tableColumnGroupDefinition.ts";
import type { UiConfiguration } from "~types/uiConfiguration.ts";
import { defaultUiConfig } from "./defaultsUi";

const seasonRosterColumnGroups: Array<TableColumnGroupDefinition> = [
  {
    titleIntlKey: "roster.columns.person.title",
    columns: [
      { key: "personId", isDefault: true },
      { key: "nameFullLocal", isDefault: true },
      { key: "person.externalId", isDefault: true },
      { key: "person.nameFullLatin" },
      { key: "person.additionalDetails.height" },
      { key: "person.additionalDetails.weight" },
      { key: "person.additionalDetails.heightImperial" },
      { key: "person.additionalDetails.weightImperial" },
      { key: "person.additionalDetails.representation" },
      { key: "person.additionalDetails.juniorAssociationLeague" },
      { key: "person.additionalDetails.homeTown" },
      { key: "person.additionalDetails.college" },
      { key: "person.additionalDetails.collegeClass" },
      { key: "person.additionalDetails.school" },
      { key: "person.additionalDetails.schoolClass" },
      { key: "dob" },
      { key: "person.gender" },
      { key: "person.nationality" },
      { key: "person.representing" },
      { key: "person.status" },
    ],
  },
  {
    titleIntlKey: "roster.columns.roster.title",
    columns: [
      { key: "bib", isDefault: true },
      { key: "externalId", isDefault: true },
      { key: "position", isDefault: true },
      { key: "status", isDefault: true },
      { key: "isCaptain", isDefault: true },
      { key: "caps", isDefault: true },
    ],
  },
];

const fixtureRosterColumnGroups: Array<TableColumnGroupDefinition> = [
  {
    titleIntlKey: "roster.columns.person.title",
    columns: [
      { key: "personId", isDefault: true },
      { key: "nameFullLocal", isDefault: true },
      { key: "person.externalId", isDefault: true },
      { key: "person.nameFullLatin" },
      { key: "person.additionalDetails.height" },
      { key: "person.additionalDetails.weight" },
      { key: "person.additionalDetails.heightImperial" },
      { key: "person.additionalDetails.weightImperial" },
      { key: "person.additionalDetails.representation" },
      { key: "person.additionalDetails.juniorAssociationLeague" },
      { key: "person.additionalDetails.homeTown" },
      { key: "person.additionalDetails.college" },
      { key: "person.additionalDetails.collegeClass" },
      { key: "person.additionalDetails.school" },
      { key: "person.additionalDetails.schoolClass" },
      { key: "dob" },
      { key: "person.gender" },
      { key: "person.nationality" },
      { key: "person.representing" },
      { key: "person.status" },
    ],
  },
  {
    titleIntlKey: "roster.columns.roster.title",
    columns: [
      { key: "bib", isDefault: true },
      { key: "externalId", isDefault: true },
      { key: "position", isDefault: true },
      { key: "starter", isDefault: true },
      { key: "status", isDefault: true },
      { key: "isCaptain", isDefault: true },
      { key: "caps", isDefault: true },
    ],
  },
];

export const hockeyUiConfig: UiConfiguration = {
  ...defaultUiConfig,
  pages: {
    ...defaultUiConfig.pages,
    seasonRoster: { tableColumnGroups: seasonRosterColumnGroups },
    fixtureRoster: { tableColumnGroups: fixtureRosterColumnGroups },
    seasonUpsert: {
      ...defaultUiConfig.pages.seasonUpsert,
      disciplines: {
        enabled: true,
        defaultDiscipline: Disciplines.Outdoor,
        isNullable: false,
      },
    },
  },
};
